import 'whatwg-fetch'
import { retrieveToken, logout } from './auth'

async function parseJSON(response) {
  return response.json()
}

async function parseTxt(response) {
  return response.text()
}

/*
* catch network request error or any other unexpected error
*/
function catchNetworkErrors(e) {
  const error = new Error(e)
  error.response = {
    status: "error",
    message: "Sin conexión a Internet"
  }
  throw error
}

function catchInvalidAPIResponse(e) {
  if (e.name === 'FetchError') {
    e.response = {
      status: "error",
      message: e.message,
    }
    throw e
  }
  throw e
}

/**
 * Checks if a network request came back fine, and throws an error if not
 */
async function checkStatus(response) {
  // response.ok is true if 200 < response.status < 299
  // +info: https://developer.mozilla.org/en-US/docs/Web/API/Response/ok
  if (response.ok) {
    const parser = !response.headers.get('Content-Type') ? parseTxt : parseJSON
    return parser(response)
  } else if(response.status === 401) {
    return logout('Invalid token.')
  } else {
    // if request was made with valid params (i.e method is allowed and URI is correct)
    // parse response as JSON to avoid parsing on each .catch() and duplicating code.
    return parseJSON(response)
      .then((json) => {
        const error = new Error(response.statusText)
        error.response = json
        throw error
      })
  }

}

/**
 * Requests a URL, returning a promise
 */
export default function request(url, {method='GET', body={}, headers={}, isUpload=false} = {}){

  headers['Accept'] = 'application/json'
  let request = {
    method: method,
    headers: {
      'Content-Type': 'application/json',
      ...headers
    },
    body: !isUpload ? JSON.stringify(body) : body
  }

  if ( isUpload ) { delete request.headers['Content-Type'] }
  if ( method === 'GET' ) { delete request.body }

  const accesToken = retrieveToken()

  if (accesToken) {
    request.headers['Authorization'] = `Token ${accesToken}`
  }

  if (process.env.NODE_ENV === 'test') {
    request.headers['Access-Control-Allow-Origin'] = '*'
  }

  return fetch(url, request)
    .catch(catchNetworkErrors)
    .then(checkStatus)
    .catch(catchInvalidAPIResponse)
}



// WEBPACK FOOTER //
// ./src/utils/request.js